import { Box } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import { ChatState } from "../Context/ChatProvider";

import MyChats from "../components/MyChats";
import ChatBox from "../components/ChatBox";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import background from "../background.png";

const ChatPage = () => {
  const { user, loading } = ChatState();
  const [fetchAgain, setFetchAgain] = useState(false);
  const navigate = useNavigate();

  // Protect this page - require authentication and check vendor approval
  useEffect(() => {
    if (loading) return; // Wait for user data to load

    if (!user) {
      navigate("/login");
      return;
    }

    if (user.role === "customer" && user.isBanned) {
      navigate("/customer-banned");
      return;
    }

    if (user.role === "vendor") {
      if (user.isApproved === "pending") {
        navigate("/vendor-pending");
      } else if (user.isApproved === "rejected") {
        navigate("/vendor-rejected");
      }
    }
  }, [user, loading, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <Helmet>
        <title>ATO | Chat</title>
        <meta
          name="description"
          content="Chat with trusted professionals and vendors on ATO. Secure, real-time messaging for all your service needs."
        />
      </Helmet>
      <div
        style={{
          width: "100%",
          backgroundImage: `url(${background})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          w="100%"
          h="91.5vh"
          p="10px"
        >
          {user && <MyChats fetchAgain={fetchAgain} />}
          {user && (
            <ChatBox fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
          )}
        </Box>
      </div>
    </>
  );
};

export default ChatPage;
